import { http } from "@di";
import actions from "./actions";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "./usecases";
const cRepositorires = repositories(http);
const cUseCases = useCases(cRepositorires);
const cActions = actions();
const cPresenters = presenters(cUseCases, cActions);
export default {
    dpBillReport: cPresenters.dpBillReport,
};
